import React, { useEffect } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';





const ProductsPropertiesCard = ({data,alldata,deleted, permission}) => {
    const {id,property_image,property_title} = data
    const handleDelete = () => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete?",
            buttons: true,
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    // swal("Successfully Delete", "", "success");
                    // apiMethodDelete(`properties/delete/${id}`)
                }

            });
    }
    const [resDelete, apiMethodDelete] = useDelete()
    useEffect(() => {
        if(resDelete.data) {
          const {message} = resDelete.data
          const update = alldata.filter((item) => item.id !== id)
          deleted(update)
          toast.success(message);
        }
      }, [resDelete.data])

 const check = (module, action) => permission?.[module]?.includes(action);
    return (
        <div className='BlogsCard group my-2 relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
            {/* {check("ProductProperties", "ProductProperties Delete") && <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10' onClick={handleDelete}>
                <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>} */}
            <Link className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center" to={`/products/properties/edit/${id}`}>
                <div className="BlogsCard__left flex h-[4rem] w-[4rem] items-center justify-center rounded-[1.25rem] bg-[#EFF4FD] lg:flex-none">
                   {property_image ? <img src={property_image} className='h-[1.8rem] w-[1.8rem] object-cover' alt={property_title} /> : <span className='text-lg font-MluvkaBold text-[#7D8CA7]'>P</span>}
                </div>
                <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
                    <div className="text-[.75rem] uppercase tracking-[0.2em] text-[#98A2B3] mb-1">Property</div>
                    <div className="text-[1.1rem] font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]">{property_title}</div>
                </div>
                <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
                    <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
                    <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
                        Edit
                    </span>
                </div>
            </Link>
        </div>
    )
}

export default ProductsPropertiesCard
